var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrafficCone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "-74 1 511 511.99998",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m215.820312 11.828125c-1.671874-6.9375-7.882812-11.828125-15.019531-11.828125h-37.464843c-7.136719 0-13.34375 4.886719-15.019532 11.824219l-114.246094 473.132812h295.996094zm0 0",
    fill: "#ff7e40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m330.066406 484.957031c-1.628906-6.746093-113.015625-468.046875-114.246094-473.132812-1.671874-6.933594-7.882812-11.824219-15.019531-11.824219h-37.460937c-7.136719 0-13.347656 4.886719-15.023438 11.828125l-4.363281 18.070313 86.675781 358.953124c4.695313 19.441407-10.039062 38.160157-30.042968 38.160157h-152.519532l-13.996094 57.945312zm0 0",
    fill: "#f05434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m336.597656 512h-309.054687c-14.933594 0-27.042969-12.109375-27.042969-27.042969 0-14.933593 12.109375-27.042969 27.042969-27.042969h309.054687c14.933594 0 27.042969 12.109376 27.042969 27.042969 0 14.933594-12.109375 27.042969-27.042969 27.042969zm0 0",
    fill: "#ff7e40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m336.035156 457.914062h-3.300781c0 12.800782-10.378906 23.179688-23.179687 23.179688h-308.777344c-.179688 1.265625-.277344 2.550781-.277344 3.863281 0 14.933594 12.109375 27.042969 27.042969 27.042969h309.054687c15.1875 0 27.449219-12.519531 27.03125-27.804688-.40625-14.726562-12.859375-26.28125-27.59375-26.28125zm0 0",
    fill: "#f05434"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m82.019531 286.394531-14.925781 61.8125h153.71875l.800781-61.8125zm0 0",
    fill: "#fff9eb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m282.121094 286.394531h-76.234375l14.925781 61.8125h76.234375zm0 0",
    fill: "#d3cdbf"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m111.871094 162.765625-14.925782 61.808594h94.015626v-61.808594zm0 0",
    fill: "#fff9eb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m252.269531 162.765625h-76.234375l14.925782 61.808594h76.230468zm0 0",
    fill: "#d3cdbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficCone);
export default __webpack_public_path__ + "static/media/traffic-cone.efb4fda8.svg";
export { ForwardRef as ReactComponent };